export default __webpack_public_path__ + "static/media/es.1beabd4f.svg";